<template>
  <div>
    <div class="block__container block__container--compact">
      <step-header-component :headerText="headerText" :subHeaderText="subHeaderText"></step-header-component>
      <generic-pricing :noAveragePriceLabel="noAveragePriceLabel"
        :averagePercentSavingLabel="averagePercentSavingLabel"
        :columnOneLabel="columnOneLabel"
        :columnTwoLabel="columnTwoLabel"
        :columnThreeLabel="columnThreeLabel"
        :pricingSmallPrint="pricingSmallPrint"/>
      <span v-html="priceDisclaimer" class="price-disclaimer"></span>

      <MotorwayValuationWrapperComponent />
      <csat :header="npsHeaderText" :tellUsMicrocopy="csatTellUsMicrocopy"></csat>
    </div>
    <div class="block--tertiary block--center">
      <div class="block__container">
        <company-details></company-details>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  Component, Prop, Vue
} from 'vue-property-decorator';
import {
  namespace
} from 'vuex-class';
import StepHeaderComponent from '../general/StepHeaderComponent.vue';
import ThanksTickComponent from '../ui/ThanksTickComponent.vue';
import CompanyDetailsComponent from '../general/CompanyDetailsComponent.vue';
import PricingDataComponent from '../pricing/PricingDataComponent.vue';
import GenericPricingComponent from '../pricing/GenericPricingComponent.vue';
import CustomerSatisfactionComponent from '../enquiry/CustomerSatisfactionComponent.vue';
import MotorwayValuationWrapperComponent from '../general/MotorwayValuationWrapperComponent.vue';

const VehicleModule = namespace('vehicleModule');

@Component({
  components: {
  'step-header-component': StepHeaderComponent,
  'thanks-tick': ThanksTickComponent,
  'company-details': CompanyDetailsComponent,
  'pricing-data': PricingDataComponent,
  'generic-pricing': GenericPricingComponent,
  csat: CustomerSatisfactionComponent,
  MotorwayValuationWrapperComponent
  }
  })

export default class ThanksStepComponentB extends Vue {
  @VehicleModule.Getter public averagePriceAvailable;

  @VehicleModule.Getter public currentDerivative;

  @Prop({ default: 'Thanks for your enquiry on the vehicleName.' })
  public headerText!: string;

  @Prop({ default: 'We will get in contact with you in the next 24 hours to fulfil your request or pass your details directly to manufacturerName and they will be in touch.' })
  public subHeaderText!: string;

  @Prop({ default: 'Our team have compared the best prices available across the UK dealer network and online over the last month to provide you with a target price that you would expect to pay if buying this car. If you would like us to help you access an accurate quote, finance or leasing price then select \'call me now\' below.' })
  public priceDisclaimer!: string;

  @Prop({ default: false })
  public showCallMeNowButton!: boolean;

  @Prop({ default: 'This is for feedback only. If you change your mind at any time, <a title="Contact us" href="mailto:datacontroller@askaprice.com">contact us</a>' })
  public csatTellUsMicrocopy!: string;

  @Prop({ default: 'How would you <span> rate your overall satisfaction </span> with the service you received today?' })
  public npsHeaderText!: string;

  @Prop({ default: 'We don\'t currently have any discount price data for the exact vehicle you\'ve selected, however we are typically seeing <span>discounts of up to averagePercent on vehicleName cars.</span>  We\'ll now work to get you a great quote.' })
  public averagePercentSavingLabel!: string;

  @Prop({ default: 'We don\'t have specific discount prices for this specific car right now but can help you get an accurate quotation from a local dealership. We\'ll ensure someone contacts you shortly to help' })
  public noAveragePriceLabel!: string;

  @Prop({ default: '' })
  public columnOneLabel!: string;

  @Prop({ default: 'Target Price' })
  public columnTwoLabel!: string;

  @Prop({ default: '' })
  public columnThreeLabel!: string;

  @Prop({ default: '*Our great price is based on market research over the last month. This does not represent a quote or offer..' })
  public pricingSmallPrint!: string;

  public get subHeaderTextFull(): string {
    return this.averagePriceAvailable ? `${this.subHeaderText} In the meantime here is your pricing data.` : this.subHeaderText;
  }

  public get enquiryDerivative() {
    return this.currentDerivative;
  }
}
</script>
